import { fetcher } from "@/lib/fetcher";
import type { SummaryResult, SummaryAPISpecResponse } from "./schemas/summary-spec-schemas";

export async function summarySystemActions(systemId: string): Promise<SummaryResult> {
  try {
    const response = await fetcher<SummaryAPISpecResponse>("/api/ai-transform/v1/api-spec/summary", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        system_id: systemId,
      }),
    });

    if (response.status === "OK" && response.data && response.data.length > 0) {
      console.log("Summary success");
      return response.data[0];
    }
    throw new Error(response.message || "Summary failed");
  } catch (error) {
    console.error("Failed to generate system summary");
    throw error;
  }
}
